import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/179/components/features/cases/OldComponents/cases/nanoteh/index.js");
